import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { TextField, Box, FormControl } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { DSText } from '@engenharia/ds-react';
import decode from 'jwt-decode';

import Logo from '../../components/molecules/Logo';
import Notification from '../../components/Notification';
import MetaHeader from '../../components/MetaHeader';
import { Container, Card, FormContainer, LinkButton } from './styles';
import Button from '../../components/atoms/Button';
import Header from '../../components/Header';
import { hasOtpToken, logout, getOtpToken } from '../../services/auth';
import { redirectUser } from '../../services/user';
import CircularLoader from '../../components/CircularLoader';

import authApi from '../../services/authApi';

export default function Verify() {
  const history = useHistory();
  const { t } = useTranslation();

  const [code, setCode] = useState('');
  const [otpName, setOtpName] = useState('');

  const [notification, setNotification] = useState({});
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  useEffect(() => {
    if (!hasOtpToken()) {
      history.push('/accounts/sign_in');
    } else {
      const otpName = decode(getOtpToken())?.otp_name;
      setOtpName(otpName);
    }
  }, []);

  const handleSendCode = async (event) => {
    try {
      const response = await authApi.post('/accounts/otp_send');
      if (response.status === 204) {
        setNotification({
          key: new Date().getTime(),
          message: t('verify.codeSended'),
        });
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        logout();
        history.push('/accounts/signin');
      } else {
        setNotification({
          key: new Date().getTime(),
          message: error?.response?.data?.message || t('errors.connection-failure'),
        });
      }
    }
  };

  const handleChange = (event) => {
    const result = event.target.value.replace(/\D/g, '');
    setCode(result);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loadingSubmit) {
      return;
    }
    if (!code) {
      setNotification({ key: new Date().getTime(), message: t('errors.login-invalid') });
    }
    setLoadingSubmit(true);
    try {
      const response = await authApi.post('/accounts/otp_verify', {
        code,
        callback_url: process.env.REACT_APP_FULL_URL,
      });
      await redirectUser(response);
    } catch (error) {
      setLoadingSubmit(false);
      console.log(error.status);
      if (error?.response?.status === 401) {
        logout();
        history.push('/accounts/signin');
      } else {
        setNotification({
          key: new Date().getTime(),
          message: error?.response?.data?.message || t('errors.connection-failure'),
        });
      }
    }
  };

  return (
    <>
      <Header positionFixed />
      <Container>
        <MetaHeader
          title="Autenticação de dois fatores - mLabs | Gestão de redes sociais"
          description="mLabs - Gestão de Redes Sociais | Autenticação de dois fatores"
        />
        <Logo />
        <Box mx={2} my={8} component={Card}>
          <DSText variant="h3" color="primary">
            {t('verify.title')}
          </DSText>
          <Box my={3}>
            <DSText variant="body2" color="textPrimary">
              {t(`verify.subtitle.${otpName}`)}
            </DSText>
          </Box>
          <FormContainer>
            <form onSubmit={handleSubmit}>
              <FormControl variant="outlined" fullWidth>
                <TextField
                  inputProps={{ required: true, maxLength: 6 }}
                  type="text"
                  id="code"
                  name="code"
                  label={t('verify.input.code')}
                  value={code}
                  onChange={handleChange}
                  variant="outlined"
                  autoComplete="off"
                  margin="normal"
                  autoFocus
                />
              </FormControl>

              <FormControl fullWidth>
                <Button
                  mt={4}
                  type="submit"
                  fullWidth
                  color="primary"
                  data-testid="formSubmit"
                  endIcon={loadingSubmit && <CircularLoader scale="0.4" />}
                >
                  {!loadingSubmit && t('verify.button')}
                </Button>
              </FormControl>
            </form>
            <LinkButton onClick={handleSendCode} variant="button" color="secondary">
              {t(`verify.sendCode.${otpName}`)}
            </LinkButton>
          </FormContainer>
        </Box>
        {notification?.key && (
          <Notification
            key={notification.key}
            index={notification.key}
            message={notification.message}
          />
        )}
      </Container>
    </>
  );
}
